module.exports = __webpack_public_path__ + "static/media/quiz-background.1dd9907d.svg";